/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconCloseSkinny8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseSkinny8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M.854.146a.5.5 0 1 0-.708.708L3.293 4 .146 7.146a.5.5 0 1 0 .708.708L4 4.707l3.146 3.147a.5.5 0 1 0 .708-.708L4.707 4 7.854.854a.5.5 0 1 0-.708-.708L4 3.293.854.146Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCloseSkinny12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseSkinny12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M1.854 1.146a.5.5 0 1 0-.708.708L5.293 6l-4.147 4.146a.5.5 0 0 0 .708.708L6 6.707l4.146 4.147a.5.5 0 0 0 .708-.708L6.707 6l4.147-4.146a.5.5 0 0 0-.708-.708L6 5.293 1.854 1.146Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCloseSkinny16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseSkinny16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M2.793 2.793a1 1 0 0 0 0 1.414L6.586 8l-3.793 3.793a1 1 0 1 0 1.414 1.414L8 9.414l3.793 3.793a1 1 0 0 0 1.414-1.414L9.414 8l3.793-3.793a1 1 0 0 0-1.414-1.414L8 6.586 4.207 2.793a1 1 0 0 0-1.414 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCloseSkinny20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseSkinny20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M17.207 4.207a1 1 0 0 0-1.414-1.414L10 8.586 4.207 2.793a1 1 0 0 0-1.414 1.414L8.586 10l-5.793 5.793a1 1 0 1 0 1.414 1.414L10 11.414l5.793 5.793a1 1 0 0 0 1.414-1.414L11.414 10l5.793-5.793Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCloseSkinny24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseSkinny24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconCloseSkinny = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseSkinny(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconCloseSkinny8 {...iconProps} />;
        case '12':
            return <IconCloseSkinny12 {...iconProps} />;
        case '16':
            return <IconCloseSkinny16 {...iconProps} />;
        case '20':
            return <IconCloseSkinny20 {...iconProps} />;
        case '24':
            return <IconCloseSkinny24 {...iconProps} />;
        default:
            return <IconCloseSkinny24 {...iconProps} />;
    }
});
